import ChangeInfo from "../components/changeOrderInfo";
import changeOrderDetail from "@/lib/data-service/flight/newFligthApi/buyer_dom_manage_changeDetail";

import PayMenthod from "@/lib/common-service/getPayModule";

import changeLog from "@/lib/data-service/flight/newFligthApi/buyer_dom_manage_order_change_log_list";
import payment from "@/lib/data-service/flight/newFligthApi/payment_params";

export default {
  name: "changPayment",
  data() {
    return {
      detailData: null,
      activeName: 'first',
      loading: true,
      orderNo: '',
      dialogVisible: false,
      payType: '',
      tableData: [],
      psgNoList: [],
      logListForm: {
        currentPage: 1,
        pageSize: 10,
        totalCount: 0
      }
    };
  },
  components: { ChangeInfo, PayMenthod },
  methods: {
    getDetail() {
      let psgNoList = typeof this.psgNoList === 'object' ? this.psgNoList : [this.psgNoList]
      changeOrderDetail({ chaOrderNo: this.orderNo, psgNoList: psgNoList }).then(res => {

        this.detailData = res.detailResult;
        this.detailData.img = res.detailResult.url.split(",")[0];
        this.detailData.imgList = res.detailResult.url.split(",");
        this.loading = false
        this.payInit()
      })
    },
    handleCurrentChange(val) {
      this.logListForm.currentPage = val
      this.getLog()
    },
    handleSizeChange(val) {
      this.logListForm.pageSize = val
      this.getLog()
    },
    getLog() {
      changeLog(this.logListForm).then(res => {
        console.log('改签', res)
        this.tableData = res.pageResult.pageData;
        this.logListForm.totalCount = res.pageResult.totalCount
      })
    },
    payInit() {
      let orderInfo
      let __this = this
      orderInfo = payment({ type: 12 })
      orderInfo.then(res => {
        this.$refs.payComponent.init({
          situationParameter: {
            '000': {
              companyId: res.companyId,
              clubId: res.clubId,
              orderNo: __this.orderNo,
              isUseCredit: __this.detailData.creditState || false,
              businessContent: res.businessContent,
              subject: '国内机票改签支付',
              orderAmount: __this.detailData.changePayAmount,
              count_down: {
                enable: false,
                // pay_remaining_seconds: __this.detailData.remainingPaymentTime,
              }
            }
          },
          //支付成功事件处理方法
          pay_successful_event_handler() {
            __this.$router.go(-1)
            __this.$message({ type: "success", message: "支付成功！" })
          },
          //支付失败事件处理方法
          pay_failed_event_handler() {
            __this.$message({ type: "warning", message: "支付失败，请重新支付！" })
          },
        });
      })
    },
  },
  activated() {
    this.orderNo = this.$route.query.ordersNo
    this.payType = this.$route.query.pay
    this.psgNoList = this.$route.query.psgNoList
    this.getDetail()
    this.getLog()
  }
};